import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { connect, useSelector } from "react-redux";
import "../App.scss";
import { Outlet } from "react-router-dom";
import { clearModals } from "../features/modals/modalSlice";
import { setGlobal } from "../features/global/globalSlice";
import { nativeOwnsAppearance } from "../functions/appearanceOwner";
import { readStoredJson, writeStoredJson } from "../functions/safeStorage";

const mapDispatch = {
  setGlobal,
  clearModals,
};

const BlankLayout = ({setGlobal, clearModals}) => {
  const [viewType, setViewType] = useState(0);
  const global = useSelector((state) => state.global);
  const darkMode = useSelector((state) => state.global.darkMode);
  const params = new URLSearchParams(window.location.search);
  const platform = useSelector((state) => state.organizer.platform);
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const windowLocation = window.location.href;

  window.closeModals = async function () {
    try {
      console.log("closeModals called from window");
      clearModals();
    } catch (error) {
      console.log(error);
      console.log("window.closeModals ERROR: ", error);
    }
  };

  
    useEffect(() => {
      const localStorageGlobal = JSON.parse(localStorage.getItem("global")) || {};
      console.log("NoNavLayout localStorageGlobal: ", localStorageGlobal);
  
      const isOverlay =
        new URL(window.location.href).pathname.split("/")[3] === "overlay";
      // SCO-2200: under the new chrome ?mode= is the single source of truth
      const darkMode = isOverlay
        ? false
        : nativeOwnsAppearance()
        ? params.get("mode") === "dark"
        : localStorageGlobal &&
          // window.location.hostname === "localhost" &&
          localStorageGlobal.hasOwnProperty("useCustomTheme") &&
          localStorageGlobal.useCustomTheme
        ? localStorageGlobal.customTheme
        : params.get("mode") !== "light"
        ? params.get("mode") === "dark" ||
          (localStorageGlobal && localStorageGlobal.darkMode)
        : false;
      console.log("NoNavLayout.js darkMode: ", darkMode);
  
      setGlobal({
        darkMode: darkMode,
        urlParams: params.size > 0 ? params : {},
      });
  
      if (darkMode) {
        document.body.classList.add("dark");
      } else {
        document.body.classList.remove("dark");
      }
    }, []);


      // The app menu's Appearance toggle calls this on live webviews (doc 05); this layout's pages (Groups, the
      // Notifications inbox, home-events, the new home, the shop) re-themed only on a reload. Same body as NoNavLayout's.
      useEffect(() => {
        window.__setAppearance__ = (mode) => {
          const dark = mode === "dark";
          writeStoredJson("global", { ...readStoredJson("global", {}), darkMode: dark });
          setGlobal({ darkMode: dark });
        };
        return () => {
          delete window.__setAppearance__;
        };
      }, []); // eslint-disable-line react-hooks/exhaustive-deps

      useEffect(() => {
        console.log("noNavLayout darkMode: ", darkMode);
        if (darkMode) {
          document.body.classList.add("dark");
        } else {
          document.body.classList.remove("dark");
        }
      }, [darkMode]);


        useEffect(() => {
          if (platform) {
            // console.log("set body class mobile");
            document.body.classList.add("mobile");
          }
        }, [platform]);

  return (
    <>
      {/* SCO-1870: rest position under native chrome — var unset (0) on plain
          web and on embedded sheet pages, so this wrapper is inert there. */}
      <div style={{ paddingTop: "var(--sh-chrome-top, 0px)" }}>
        <Outlet />
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default connect(null, mapDispatch)(BlankLayout);
